import { render, staticRenderFns } from "./LargeRadioButton.vue?vue&type=template&id=31d5e4c3"
import script from "./LargeRadioButton.vue?vue&type=script&lang=js"
export * from "./LargeRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports